import React from 'react';
import { useNavigate } from 'react-router-dom';

const BottomNav = () => {
  const navigate = useNavigate();

  return (
    <div className="bottom-nav">
      <i 
        className="fas fa-home nav-icon"
        onClick={() => navigate('/dashboard')}
        style={{fontSize: '1.5rem', cursor: 'pointer'}}
      />
      <i 
        className="fas fa-arrow-left nav-icon"
        onClick={() => navigate(-1)}
        style={{fontSize: '1.5rem', cursor: 'pointer'}}
      />
      <i 
        className="fas fa-newspaper nav-icon"
        onClick={() => navigate('/news')}
        style={{fontSize: '1.5rem', cursor: 'pointer'}}
      />
      <i 
        className="fas fa-user nav-icon"
        onClick={() => navigate('/profile')}
        style={{fontSize: '1.5rem', cursor: 'pointer'}}
      />
    </div>
  );
};

export default BottomNav;
